import React, {
    PropTypes,
} from 'react';
import {Table, Panel} from 'react-bootstrap';

class ActDetails extends React.Component {
    static propTypes = {
        operations: PropTypes.array.isRequired,
        payerFio: PropTypes.string.isRequired,
        balanceText: PropTypes.string.isRequired,
        balanceBeginText: PropTypes.string.isRequired,
        payedTotal: PropTypes.string.isRequired,
        accruedTotal: PropTypes.string.isRequired,
        balanceEndText: PropTypes.string.isRequired,
        totalText: PropTypes.string.isRequired,
        currentName: PropTypes.string.isRequired,
        beginDt: PropTypes.object.isRequired,
        endDt: PropTypes.object.isRequired
    };

    getDateString(date) {
        const dt = (('0' + date.getDate()).slice(-2));
        const month = (('0' + (date.getMonth() + 1)).slice(-2));

        return date.getFullYear() + '-' + month + '-' + dt;
    }

    render() {
        const {operations, payerFio, balanceText, balanceBeginText, totalText, currentName, payedTotal, accruedTotal, balanceEndText} = this.props;


        return (
            <div>
                <Panel
                    header={<h2>Акт звірки</h2>}
                    footer={<strong>{totalText}</strong>}
                >
                    <div style={{textAlign: 'center'}}>
                        Взаєморозрахунків між Приватною школою «Афіни» <br/>
                        та {payerFio}, <br/>
                        учень {currentName}<br/><br/>
                    </div>
                    {balanceText}
                    <Table condensed hover className="mt15 my-table">
                        <thead>
                        <tr>
                            <th>Послуги</th>
                            <th>Дата операції</th>
                            <th>Сплачено</th>
                            <th>Нараховано</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr><th colSpan={4}>{balanceBeginText}</th></tr>
                        {operations.map(op => <tr>
                            <td>{op.waresName}</td>
                            <td>{op.date}</td>
                            <td>{op.payed}</td>
                            <td>{op.accrued}</td>
                        </tr>)}
                        <tr>
                            <th colSpan={2}>Обороти за період</th>
                            <th>{payedTotal}</th>
                            <th>{accruedTotal}</th>
                        </tr>
                        <tr><th colSpan={4}>{balanceEndText}</th></tr>
                        </tbody>
                    </Table>
                </Panel>
            </div>
        );
    };
}

export default ActDetails;



/** WEBPACK FOOTER **
 ** ./src/modules/finance/ActDetails.js
 **/